import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { PREFECTURES, REGIONS } from 'Src/me/pages/guest/proposals/new/consts';
import { WallAndRoofSvg } from '../assets/WallAndRoof.svg';
import { WallSvg } from '../assets/Wall.svg';
import { UnknownSvg } from '../assets/Unknown.svg';
import { RollerSvg } from '../assets/Roller.svg';
import { ParallaxSvg } from '../assets/Parallax.svg';
import { TrowelSvg } from '../assets/Trowel.svg';

const iconElementCommonStyle = css`
  font-size: 0;
  display: block;
  margin-inline: auto;
  margin-bottom: 12px;
`;

export type AnswersType = {
  id: number;
  answerText: string;
  value: string;
  checked: boolean;
  regionId?: number;
  iconElement?: React.ReactElement;
};
export type AnswerGroupType = {
  id: number;
  keyName: string;
  paramName: string;
  question: string;
  answers: AnswersType[];
};

export const ANSWER_KEY_NAMES = ['region', 'prefecture', 'constructionParts', 'wallConstructionType'] as const;
export const lastAnswerKeyName = ANSWER_KEY_NAMES[ANSWER_KEY_NAMES.length - 1];
export const ANSWER_GROUPS: AnswerGroupType[] = [
  {
    id: 1,
    keyName: 'region',
    paramName: 'region',
    question: '地域は',
    answers: REGIONS.map((region) => {
      const { id, name } = region;
      return { id, answerText: name, value: name, checked: false };
    }),
  },
  {
    id: 2,
    keyName: 'prefecture',
    paramName: 'prefecture',
    question: '',
    answers: PREFECTURES.map((prefecture) => {
      const { id, name, regionId } = prefecture;
      return { id, answerText: name, value: name, regionId, checked: false };
    }),
  },
  {
    id: 3,
    keyName: 'constructionParts',
    paramName: 'constructionParts',
    question: '工事箇所は',
    answers: [
      {
        id: 1,
        answerText: '外壁と屋根',
        value: '外壁と屋根',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 43px;
            `}
          >
            <WallAndRoofSvg />
          </span>
        ),
      },
      {
        id: 2,
        answerText: '外壁',
        value: '外壁',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 43px;
            `}
          >
            <WallSvg />
          </span>
        ),
      },
      {
        id: 3,
        answerText: '決まっていない',
        value: '決まっていない',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 29px;
            `}
          >
            <UnknownSvg />
          </span>
        ),
      },
    ],
  },
  {
    id: 3,
    keyName: 'wallConstructionType',
    paramName: 'wallConstructionType',
    question: '工事種別は',
    answers: [
      {
        id: 1,
        answerText: '塗装',
        value: '塗装',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 57px;
            `}
          >
            <RollerSvg />
          </span>
        ),
      },
      {
        id: 2,
        answerText: '張り替え',
        value: '張り替え',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 48px;
            `}
          >
            <ParallaxSvg />
          </span>
        ),
      },
      {
        id: 3,
        answerText: '補修',
        value: '補修',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 52px;
            `}
          >
            <TrowelSvg />
          </span>
        ),
      },
      {
        id: 4,
        answerText: '決まっていない',
        value: '決まっていない',
        checked: false,
        iconElement: (
          <span
            css={css`
              ${iconElementCommonStyle}

              width: 29px;
            `}
          >
            <UnknownSvg />
          </span>
        ),
      },
    ],
  },
];
